// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
// Copyright (C) 2024 Northwestern University.
//
// InvenioRDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

// This file is a direct copy-paste of
// https://github.com/inveniosoftware/invenio-app-rdm/blob/master/invenio_app_rdm/theme/assets/semantic-ui/js/invenio_app_rdm/landing_page/RecordCommunitiesListModal/RecordCommunitiesSearchItem.js
// with adaptation to address #757 (branding removal)

import React, { Component } from "react";
import { CommunityCompactItem } from "@js/invenio_communities/community";
import PropTypes from "prop-types";
// PRISM: Adapt import
import { RemoveFromCommunityAction } from "/js/invenio_app_rdm/landing_page/RemoveFromCommunity/RemoveFromCommunityAction";

export class GalterPrismRecordCommunitiesSearchItem extends Component {
  render() {
    const {
      result,
      successCallback,
      recordCommunityEndpoint,
      recordParent,
      permissions: { can_manage: canManage },
    } = this.props;

    const isCommunityDefault = recordParent?.communities?.default === result?.id;
    const actions = canManage && (
      <>
        {/** PRISM: Removed ManageDefaultBrandingAction until https://github.com/inveniosoftware/invenio-app-rdm/issues/2869 is fixed. */}
        <RemoveFromCommunityAction
          result={result}
          recordCommunityEndpoint={recordCommunityEndpoint}
          successCallback={successCallback}
        />
      </>
    );
    {/** PRISM: Always set isCommunityDefault to false so no "branding" pill is rendered. */}
    return (
      <CommunityCompactItem
        actions={actions}
        result={result}
        isCommunityDefault={false}
      />
    );
  }
}

GalterPrismRecordCommunitiesSearchItem.propTypes = {
  result: PropTypes.object.isRequired,
  recordCommunityEndpoint: PropTypes.string.isRequired,
  successCallback: PropTypes.func.isRequired,
  updateRecordCallback: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  recordParent: PropTypes.object.isRequired,
};
